import React from "react"
import { Icon, Info, OperationData, OperationWrapper } from "./Shared.styled"
import dayjs from "dayjs"
import { v4 as uuidv4 } from "uuid"


type Props = {
  numberOfOperations: number
}

const LoadingOperations = ({ numberOfOperations }: Props) => {
  return (
    <>
      {[...Array(numberOfOperations)].map(() => (
        <OperationWrapper className={"blur"} key={uuidv4()} $color={"#2E7D32"}>
          <Info>
            <OperationData>Store group</OperationData>
            <b>Order ref: 123ref</b>
            <OperationData>
              <b>Type</b>
            </OperationData>
            <OperationData>{dayjs().format("YYYY-MM-DD HH:mm")}</OperationData>
            <OperationData>name@brinkcommerce.com</OperationData>
          </Info>
          <Icon />
        </OperationWrapper>
      ))}
    </>
  )
}

export default LoadingOperations
